import type { IconProps } from './../../models/icon';

export function PriceTagIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill={secondaryColor}
          d="M22.714 16.7956L16.0455 23.4641C15.8044 23.705 15.4777 23.8402 15.1369 23.8402C14.7962 23.8402 14.4694 23.705 14.2284 23.4641L3.06837 12.3042C3.00187 12.2406 2.95042 12.163 2.9178 12.077C2.88518 11.991 2.8722 11.8987 2.87979 11.807L3.89122 5.22419C3.90302 5.07354 3.96821 4.93204 4.07508 4.82519C4.18193 4.71832 4.32343 4.65312 4.47408 4.64133L11.0569 3.6299C11.1486 3.62231 11.2408 3.63528 11.3269 3.66791C11.4129 3.70053 11.4905 3.75198 11.5541 3.81847L22.714 14.9785C22.9549 15.2196 23.0901 15.5463 23.0901 15.887C23.0901 16.2278 22.9549 16.5546 22.714 16.7956Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.714 16.7956L16.0455 23.4641C15.8044 23.705 15.4777 23.8402 15.1369 23.8402C14.7962 23.8402 14.4694 23.705 14.2284 23.4641L3.06837 12.3042C3.00187 12.2406 2.95042 12.163 2.9178 12.077C2.88518 11.991 2.8722 11.8987 2.87979 11.807L3.89122 5.22419C3.90302 5.07354 3.96821 4.93204 4.07508 4.82519C4.18193 4.71832 4.32343 4.65312 4.47408 4.64133L11.0569 3.6299C11.1486 3.62231 11.2408 3.63528 11.3269 3.66791C11.4129 3.70053 11.4905 3.75198 11.5541 3.81847L22.714 14.9785C22.9549 15.2196 23.0901 15.5463 23.0901 15.887C23.0901 16.2278 22.9549 16.5546 22.714 16.7956Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M6.90869 7.65862L0.908691 1.65862"
        />
      </g>
    </svg>
  );
}
